const hiddenClass = "selling_plan_theme_integration--hidden";
class SellingPlansWidget {
    constructor(sellingPlansWidgetContainer) {
        this.enablePerformanceObserver(),
        this.sellingPlansWidgetContainer = sellingPlansWidgetContainer,
        this.appendSellingPlanInputs(),
        this.updateSellingPlanInputsValues(),
        this.listenToVariantChange(),
        this.listenToSellingPlanFormRadioButtonChange(),
        this.initializeSubscriptionWidget(),
        this.updatePrice()
    }
    initializeSubscriptionWidget() {
        const widget = this.sellingPlansWidgetContainer
          , oneTimeBtn = widget.querySelector(".subscription-widget__item-onetime")
          , subscribeBtn = widget.querySelector(".subscription-widget__item-subscribe")
          , items = widget.querySelectorAll(".subscription-widget__item");
        if (widget.querySelectorAll('input[type="radio"]').forEach(radio => {
            radio.addEventListener("change", event => {
                const sellingPlanId = event.target.getAttribute("data-selling-plan-id") || "";
                document.querySelectorAll(".selected-selling-plan-id").forEach(input => {
                    input.value = sellingPlanId,
                    console.log("Setting selling plan ID to:", sellingPlanId)
                }
                )
            }
            )
        }
        ),
        oneTimeBtn && oneTimeBtn.addEventListener("click", () => {
            items.forEach(item => item.classList.remove("selected")),
            oneTimeBtn.closest(".subscription-widget__item").classList.add("selected"),
            oneTimeBtn.setAttribute("aria-expanded", "true"),
            subscribeBtn && subscribeBtn.setAttribute("aria-expanded", "false");
            const radioBtn = oneTimeBtn.querySelector('input[type="radio"]');
            radioBtn && (radioBtn.checked = !0,
            radioBtn.dispatchEvent(new Event("change")))
        }
        ),
        subscribeBtn) {
            subscribeBtn.addEventListener("click", () => {
                items.forEach(item => item.classList.remove("selected")),
                subscribeBtn.closest(".subscription-widget__item").classList.add("selected"),
                subscribeBtn.setAttribute("aria-expanded", "true"),
                oneTimeBtn && oneTimeBtn.setAttribute("aria-expanded", "false");
                const subscriptionRadios2 = subscribeBtn.closest(".subscription-widget__item").querySelectorAll('.subscription-widget__selectors-radio-subscriptions input[type="radio"]');
                !Array.from(subscriptionRadios2).find(radio => radio.checked) && subscriptionRadios2.length > 0 && (subscriptionRadios2[0].checked = !0,
                subscriptionRadios2[0].dispatchEvent(new Event("change")))
            }
            ),
            items.forEach(item => item.classList.remove("selected")),
            subscribeBtn.closest(".subscription-widget__item").classList.add("selected"),
            subscribeBtn.setAttribute("aria-expanded", "true"),
            oneTimeBtn && oneTimeBtn.setAttribute("aria-expanded", "false");
            const subscriptionRadios = subscribeBtn.closest(".subscription-widget__item").querySelectorAll('.subscription-widget__selectors-radio-subscriptions input[type="radio"]');
            subscriptionRadios.length > 0 && (subscriptionRadios[0].checked = !0,
            subscriptionRadios[0].dispatchEvent(new Event("change")))
        }
        const subscriptionLabels = widget.querySelectorAll(".subscription-widget__selectors-label");
        subscriptionLabels.forEach(label => {
            const radio = label.querySelector('input[type="radio"]');
            radio && radio.addEventListener("change", () => {
                subscriptionLabels.forEach(l => {
                    l.querySelector(".subscription-widget__selectors-radio-subscriptions").removeAttribute("data-checked")
                }
                ),
                radio.checked && label.querySelector(".subscription-widget__selectors-radio-subscriptions").setAttribute("data-checked", "")
            }
            )
        }
        )
    }
    get sectionId() {
        return this.sellingPlansWidgetContainer.getAttribute("data-section-id")
    }
    get shopifySection() {
        return document.querySelector(`#shopify-section-${this.sectionId}`)
    }
    get variantIdInput() {
        return this.addToCartForms[1]?.querySelector('input[name="id"]') || this.addToCartForms[1]?.querySelector('select[name="id"]') || this.addToCartForms[0].querySelector('input[name="id"]') || this.addToCartForms[0].querySelector('select[name="id"]')
    }
    get priceElement() {
        return this.shopifySection.querySelector(".price")
    }
    get comparedAtPrice() {
        return this.shopifySection.querySelector(".price__sale")
    }
    get visibleSellingPlanForm() {
        return this.shopifySection.querySelector(`section[data-variant-id^="${this.variantIdInput.value}"]`)
    }
    get isVariantAvailable() {
        return this.selectedPurchaseOption.getAttributeNames().includes("disabled")
    }
    get sellingPlanInput() {
        return this.shopifySection.querySelector(".selected-selling-plan-id")
    }
    get addToCartForms() {
        return this.shopifySection.querySelectorAll('[action*="/cart/add"]')
    }
    appendSellingPlanInputs() {
        this.addToCartForms.forEach(addToCartForm => {
            addToCartForm.appendChild(this.sellingPlanInput.cloneNode())
        }
        )
    }
    showSellingPlanForm(sellingPlanFormForSelectedVariant) {
        sellingPlanFormForSelectedVariant?.classList?.remove(hiddenClass)
    }
    hideSellingPlanForms(sellingPlanFormsForUnselectedVariants) {
        sellingPlanFormsForUnselectedVariants.forEach(element => {
            element.classList.add(hiddenClass)
        }
        )
    }
    handleSellingPlanFormVisibility() {
        const sellingPlanFormForSelectedVariant = this.shopifySection.querySelector(`section[data-variant-id="${this.variantIdInput.value}"]`)
          , sellingPlanFormsForUnselectedVariants = this.shopifySection.querySelectorAll(`.subscription-widget__variant-section:not([data-variant-id="${this.variantIdInput.value}"])`);
        this.showSellingPlanForm(sellingPlanFormForSelectedVariant),
        this.hideSellingPlanForms(sellingPlanFormsForUnselectedVariants)
    }
    handleVariantChange() {
        this.handleSellingPlanFormVisibility(),
        this.updateSellingPlanInputsValues(),
        this.listenToSellingPlanFormRadioButtonChange()
    }
    listenToVariantChange() {
        this.listenToAddToCartForms(),
        this.variantIdInput.tagName === "INPUT" && new MutationObserver(mutationList => {
            mutationList.forEach(mutationRecord => {
                this.handleVariantChange(mutationRecord.target.value)
            }
            )
        }
        ).observe(this.variantIdInput, {
            attributes: !0
        })
    }
    listenToAddToCartForms() {
        this.addToCartForms.forEach(addToCartForm => {
            addToCartForm.addEventListener("change", () => {
                this.handleVariantChange()
            }
            )
        }
        )
    }
    get regularPriceElement() {
        return this.shopifySection.querySelector(".product-block--price")
    }
    get salePriceElement() {
        return this.shopifySection.querySelector(".product-block--price-sale")
    }
    get salePriceValue() {
        return this.salePriceElement?.querySelector(".product__price")
    }
    get regularPriceValue() {
        return this.regularPriceElement.querySelector(".product__price")
    }
    get sellingPlanAllocationPrice() {
        return document.getElementById(`${this.selectedPurchaseOption.dataset.sellingPlanGroupId}_allocation_price`)
    }
    get selectedPurchaseOptionPrice() {
        return this.selectedPurchaseOption.dataset.variantPrice
    }
    get selectedPurchaseOptionComparedAtPrice() {
        return this.selectedPurchaseOption.dataset.variantCompareAtPrice
    }
    updatePrice() {
        !this.selectedPurchaseOptionComparedAtPrice || this.selectedPurchaseOptionComparedAtPrice === this.selectedPurchaseOptionPrice ? (this.showRegularPrice(),
        this.hideSalePrice(),
        this.priceElement?.classList.remove("price--on-sale")) : (this.showSalePrice(),
        this.hideRegularPrice(),
        this.priceElement?.classList.add("price--on-sale")),
        this.updateWidgetPrices()
    }
    updateWidgetPrices() {
        const selectedRadio = this.selectedPurchaseOption;
      console.log("selectedPurchaseOption",selectedRadio);
        if (!selectedRadio) return;
        
        // Find the subscription widget container first
        const widgetContainer = selectedRadio.closest('.subscription-widget');
        
        // Then find the selected widget item within that container
        const selectedWidget = widgetContainer?.querySelector('.subscription-widget__item.selected');
        
        if (selectedWidget) {
            const priceDisplay = selectedWidget.querySelector(".subscription-widget__item-price");
            priceDisplay && (priceDisplay.textContent = selectedRadio.getAttribute('data-variant-price'));
        } else {
            console.log("No selected widget found");
        }
    }
    hideSalePrice() {
        this.salePriceElement && (this.salePriceElement.style.display = "none")
    }
    hideRegularPrice() {
        this.regularPriceElement && (this.regularPriceElement.style.display = "none")
    }
    showRegularPrice() {
        this.regularPriceElement && (this.regularPriceElement.style.display = "block"),
        this.salePriceElement && (this.salePriceElement.style.display = "none")
    }
    showSalePrice() {
        this.salePriceElement && (this.salePriceElement.style.display = "block"),
        this.regularPriceValue && (this.regularPriceValue.innerHTML = this.selectedPurchaseOptionComparedAtPrice),
        this.salePriceValue && (this.salePriceValue.innerHTML = this.selectedPurchaseOptionPrice)
    }
    get sellingPlanInputs() {
        return this.shopifySection.querySelectorAll(".selected-selling-plan-id")
    }
    updateSellingPlanInputsValues() {
        document.querySelectorAll(".selected-selling-plan-id").forEach(sellingPlanInput => {
            const selectedOption = this.selectedPurchaseOption;
            if (!selectedOption) {
                console.log("No selected purchase option found");
                return
            }
            selectedOption.dataset.radioType === "one_time_purchase" ? (sellingPlanInput.value = "",
            console.log("One-time purchase selected, clearing selling plan ID")) : selectedOption.dataset.sellingPlanId ? (sellingPlanInput.value = selectedOption.dataset.sellingPlanId,
            console.log("Updated selling plan ID to:", sellingPlanInput.value)) : console.log("No selling plan ID found on selected option:", selectedOption)
        }
        )
    }
    get sellingPlanInputValue() {
        return this.selectedPurchaseOption?.dataset.sellingPlanId ?? null
    }
    get selectedPurchaseOption() {
        const checkedDiv = document.querySelector('.subscription-widget__selectors-radio-subscriptions[data-checked]') || document.querySelector('.subscription-widget__item.selected .subscription-widget__selectors-radio-subscriptions');
        const selectedRadio = checkedDiv?.querySelector('input[type="radio"]');
        return selectedRadio;
        
        //const checkedRadio = this.visibleSellingPlanForm?.querySelector('input[type="radio"]:checked');
        //return checkedRadio || this.sellingPlansWidgetContainer.querySelector('input[type="radio"]:checked')
    }
    handleRadioButtonChange(selectedPurchaseOption) {
        console.log("Radio button changed:", selectedPurchaseOption);
        const sellingPlanId = selectedPurchaseOption.getAttribute("data-selling-plan-id") || "";
        document.querySelectorAll(".selected-selling-plan-id").forEach(input => {
            input.value = sellingPlanId,
            console.log("Setting selling plan ID to:", sellingPlanId)
        });

        
      const label = selectedPurchaseOption.closest(".subscription-widget__selectors-label");
        label && (label.closest(".subscription-widget__selectors-radiogroup").querySelectorAll(".subscription-widget__selectors-label").forEach(l => {
            l.querySelector(".subscription-widget__selectors-radio-subscriptions").removeAttribute("data-checked")
        }
        ),
        label.querySelector(".subscription-widget__selectors-radio-subscriptions").setAttribute("data-checked", ""));

        if (selectedPurchaseOption.getAttribute("data-radio-type") === "one_time_purchase") {
          document.querySelectorAll(".subscription-widget__selectors-radio-subscriptions").forEach(e => {
            e.removeAttribute("data-checked");
          });
          document.querySelector(".subscription-widget__item.selected .subscription-widget__selectors-radio-subscriptions").setAttribute("data-checked","true");
        }
      
        const qtyField = document.querySelector(".main-content .js-qty__num");
        if (qtyField) {
            const onetimeCount = selectedPurchaseOption.getAttribute("data-onetime-count");
            console.log("onetimeCount:", onetimeCount);
            console.log("qtyField:", qtyField);
            onetimeCount ? qtyField.value = onetimeCount : qtyField.value = 1
        }
        this.updatePrice()
    }
    listenToSellingPlanFormRadioButtonChange() {
        this.sellingPlansWidgetContainer.querySelectorAll('input[type="radio"]').forEach(radio => {
            radio.removeEventListener("change", this.handleRadioChange),
            radio.addEventListener("change", event => {
                this.handleRadioButtonChange(event.target)
            }
            )
        }
        )
    }
    enablePerformanceObserver() {
        new PerformanceObserver(list => {
            list.getEntries().forEach(entry => {
                if (entry.initiatorType !== "fetch")
                    return;
                const url = new URL(entry.name);
                (url.search.includes("variant") || url.search.includes("variants")) && this.updatePrice()
            }
            )
        }
        ).observe({
            entryTypes: ["resource"]
        })
    }
}
document.querySelectorAll(".subscription-widget").forEach(sellingPlansWidgetContainer => {
    new SellingPlansWidget(sellingPlansWidgetContainer)
}
);
//# sourceMappingURL=/cdn/shop/t/3/assets/selling-plans-integration.js.map?v=164615987968160983421752820703
